class SubscriptionFeatures extends HTMLElement {
    connectedCallback() {
        if (this.hasAnimated) return
        this.hasAnimated = true

        const innerSpans = this.querySelectorAll('[data-inner-span]')
        const outerSpans = this.querySelectorAll('[data-outer-span]')

        // Load animation
        this.introTl = gsap.timeline({
            defaults: {
                duration: 1.2,
                ease: 'power4.out',
                delay: 0.25,
            }
        })

        this.introTl.to(innerSpans, {
            y: 0,
            stagger: 0.15

        })

        // Scroll animation
        this.scrollTl = gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'top top',
                end: 'bottom top',
                scrub: 1
            }
        })

        this.scrollTl.to(outerSpans, {
            yPercent: -100,
            ease: 'none',
            duration: 1,
            stagger: { amount: 0.15, from: 'end' }
        })
    }
}

customElements.define('subscription-features', SubscriptionFeatures)